import type { CustomerPermissionsRole } from '@/enums';

import { useUserProfile } from '@/hooks/useUsers';
import isEmpty from 'lodash/isEmpty';
import { Navigate } from 'react-router';

export default function PermissionRoleGuard({
  children,
  permissionsRole,
  redirect,
  rootAdmin,
}: Readonly<{
  children: React.ReactNode;
  permissionsRole: CustomerPermissionsRole;
  redirect?: string;
  rootAdmin?: boolean;
}>) {
  const { organizationRoles = [], parentOrganizationCode } = useUserProfile();

  if (
    !organizationRoles.includes(permissionsRole) ||
    (rootAdmin && !isEmpty(parentOrganizationCode))
  ) {
    return redirect ? <Navigate to={redirect} /> : null;
  }

  return <>{children}</>;
}
